<template>
  <NuxtLoadingIndicator color="repeating-linear-gradient(to right,var(--bg-primary) 0%, var(--bg-primary) 100%)" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
